import React, { useContext } from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import { AuthContext, AuthProvider } from './context/AuthContext';
import { AnimatePresence } from 'framer-motion';

import Login from './components/Login';
import Signup from './components/Signup';
import Dashboard from './components/Dashboard';
import Home from './components/Home';
import Error from './components/Error';
import ForgotPassword from './components/ForgotPassword';
import QuotationApp from './components/Dashboards/QuotationApp';
import ProductsManager from './components/Dashboards/ProductsManager';
import ClientsManager from './components/Dashboards/ClientsManager';
import PICreator from './components/Dashboards/QuotationApp';
import PIView from "./components/elements/PIView";
import PIList from './components/Dashboards/PIList';
import DashboardHome from './components/Dashboards/DashboardHome';


const App = () => {
  const { user, logout } = useContext(AuthContext);
  return (
    <Router>
     <AnimatePresence >
      <Routes  >
        <Route path="/" element={<Home/>} />
        <Route path="/login" element={<Login />} />
        <Route path="/forgot-password" element={<ForgotPassword />} />
        <Route path="/signup" element={<Signup />} />
        <Route element={<Dashboard />}>

            {user?.role === "user"  && (
              <>
                <Route path="/dashboard" element={<Dashboard />} />
              </>
            )}
           {user?.role === "volunteer"  && (
              <>
                <Route path="/dashboard" element={<Dashboard />} />
              </>
            )}
            {user?.role === "admin"  && (
              <>
                <Route path="/dashboard" element={<DashboardHome/>} />
                <Route path="/dashboard/pi" element={<PICreator />} />
                <Route path="/dashboard/products" element={<ProductsManager />} />
                <Route path="/dashboard/clients" element={<ClientsManager />} />
                <Route path="/pi/:id" element={<PIView />} />
                <Route path="/dashboard/pi-list" element={<PIList />} />


              </>
            )}
            <Route path="*" element={<Error/>} />
        </Route>
      </Routes>
      </AnimatePresence>
    </Router>
  );
};

const RootApp = () => (
  <AuthProvider> 
    <App />
  </AuthProvider>
);

export default RootApp;
